module.exports = __webpack_public_path__ + "img/symbol_8.eb8e83c2.png";